import { createFileRoute } from '@tanstack/react-router';

import { DiagnosticoCarteraView } from '@/features/diagnostico-tributario/components/diagnostico-cartera-view';

export const Route = createFileRoute('/_app/diagnostico-tributario/')({
  component: DiagnosticoCarteraView,
});
